import React, { useEffect, useState } from "react";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import SocketService, { socket } from "../../../service/socket/SocketService";
import Div from "../../common/ui/Div";
import Center from "../../common/ui/Center";
import { LogoRound } from "../../common/ui/Logo";
import { SpacingHeight } from "../../common/ui/Spacing";
import { TextBlock } from "../../common/ui/Text";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import { textCase } from "../../../service/ui/UI";
import PincodeInput from "../../common/ui/PincodeInput";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { useDispatch } from "react-redux";
import { removeAllModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import Loader from "../../common/ui/Loader";
import SocketChatsKeys from "../../../const/SocketChatsKeys";
import { navigate } from "../../../service/navigation/Navigation";
import { appRoutes } from "../../../routes/routes";
import { ConversationList } from "../../../model/chats/ChatListModel";
import CacheStorage from "../../../service/storage/CacheStorage";
import AppConfigService from "../../../service/app_config/AppConfigService";

const DetailConnectDepartment = () => {
  const type: number = ResponsiveDeviceType();

  const dispatch = useDispatch();

  const detailDeptChat = useSelector(
    (state: RootState) => state.detailConnectDeptChat.detailDeptChat
  );

  const pincodeLength = 6;
  console.log(detailDeptChat);
  const [branchName, setBranchName] = useState<string>("");
  const [branchLogo, setBranchLogo] = useState<string>("");
  const [code, setCode] = useState<string>("");

  const initDeptData = () => {
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    const branchLogoSession: string = CacheStorage.getValue(
      StorageKeys.branch_logo
    );

    setBranchName(branchNameSession);
    setBranchLogo(branchLogoSession);
  };

  const connectProper = async () => {
    Loader.modal();
    const connectStatus: boolean = await SocketService.initialize();
    await UtilityHelper.delay();
    Loader.modal(false);

    if (connectStatus && detailDeptChat != null) {
      Loader.modal();
      await SocketService.initConversation({
        flag: "2",
        eventN: SocketChatsKeys.check_dept_contact_request,
        profId: detailDeptChat.chat_id,
        branchId: CacheStorage.getValue(StorageKeys.branch_id) || "0",
        callback: async (response: any) => {
          console.log(response);

          navigateTo(response["results"]);
        },
      });
    }
  };

  const navigateTo = async (detail: any) => {
    dispatch(removeAllModal());

    Loader.modal(false);
    const flag: string = detail["flag"] ?? "0";

    const conversDetail: ConversationList = {
      conv_id: detail["conv_id"],
      flag: detail["flag"],
      account_id: detail["department_id"],
      account_type: "4",
      name: detail["name"],
      title: detail["title"],
      logo: detail["logo"],
      unread_count: detail["conv_settings"]["unread_count"],
      conv_settings: {
        unread_count: detail["conv_settings"]["unread_count"],
        mute_status:
          detail["conv_settings"]["muted_conversations"]["mute_status"],
      },
    };

    SessionStorage.saveValue(
      StorageKeys.chats_chat_selected,
      JSON.stringify(conversDetail)
    );

    SessionStorage.saveValue(StorageKeys.chats_popup_connect, "1");

    navigate(appRoutes.routeNameChats);
    if (flag === "2") {
      navigate(appRoutes.routeNameChatDepartment);
    }
  };

  const verifyCode = (codeVal: string) => {
    if (
      codeVal.length === pincodeLength &&
      code === detailDeptChat?.access_passcode
    ) {
      connectProper();
    }
  };

  useEffect(() => {
    verifyCode(code);
    // eslint-disable-next-line
  }, [code]);

  useEffect(() => {
    initDeptData();

    return () => {
      if (socket.connected) {
        SocketService.disconnect();
        console.log(`socket disconnect - DEPT RESTRICTED popup connect`);
      }
    };
  }, []);

  return (
    <Div className={`pt-4 pb-${type === 3 ? 1 : 3}`}>
      <Div>
        <Center>
          <LogoRound
            url={branchLogo || AppConfigService.get("company_logo")}
            size={type !== 2 ? 100 : 180}
            name={branchName}
          />
        </Center>
        <SpacingHeight value={type === 1 ? 40 : 50} />
        <TextBlock
          center={true}
          fontSize="20_21"
          fontName="bold"
          textColor="theme-label"
        >
          {textCase(detailDeptChat?.chat_title!)}
        </TextBlock>

        <Div className="pt-4">
          <PincodeInput
            length={pincodeLength}
            onChange={setCode}
            resetStatus={false}
            layout="clean"
          />
        </Div>

        {UtilityHelper.isNotEmpty(detailDeptChat?.access_passcode ?? "") &&
          code.length === pincodeLength &&
          code !== detailDeptChat?.access_passcode && (
            <TextBlock
              center={true}
              fontSize="13_14"
              fontName="book"
              textColor="primary"
              className="pt-3"
            >
              {AppTranslation.text(
                "invalid_passcode_please_enter_valid_passcode"
              )}
            </TextBlock>
          )}
      </Div>
    </Div>
  );
};

export default DetailConnectDepartment;
